import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Hero from 'components/hero/PriceListHero';
import axios from 'axios';
import PriceListSection from 'components/priceList/PriceListSection';
import Faq from 'components/faq/Faq';
import ReservationSection from 'components/reservation/ReservationSection';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next';

type Props = {
  standardPriceData: Array<PriceData>;
  vipPriceData: Array<PriceData>;
};

export type PriceData = {
  id: number;
  attributes: {
    Cena: string;
    locale: string;
    title: string;
    localizations: {
      data: [
        {
          attributes: {
            Cena: string;
            locale: string;
            title: string;
          };
        }
      ];
    };
  };
};

const PriceList = ({ standardPriceData, vipPriceData }: Props) => {
  const { t, i18n } = useTranslation('priceList');
  return (
    <>
      <NextSeo
        title={t('meta.title') || ''}
        description={t('meta.desc') || ''}
        openGraph={{ title: t('meta.title') || '', description: t('meta.desc') || '' }}
      />
      <Hero type='standard'></Hero>
      <PriceListSection priceList={standardPriceData[i18n.language as any]}></PriceListSection>
      <Hero type='VIP'></Hero>
      <PriceListSection priceList={vipPriceData[i18n.language as any]}></PriceListSection>
      <ReservationSection></ReservationSection>
      <Faq></Faq>
    </>
  );
};

export default PriceList;

export async function getStaticProps({ locale }: any) {
  let standardPriceData;
  let vipPriceData;
  try {
    const standardPriceDataCSResponse = await axios.get(`${process.env.API_URL}/api/cenik-standard2?populate=*&locale=cs`, {
      headers: { Authorization: `Bearer ${process.env.STRAPI_TOKEN}` },
    });
    // console.log(standardPriceDataResponse.data);
    const standardPriceCSData = standardPriceDataCSResponse.data.data.attributes.priceList;

    const standardPriceDataENResponse = await axios.get(`${process.env.API_URL}/api/cenik-standard2?populate=*&locale=en`, {
      headers: { Authorization: `Bearer ${process.env.STRAPI_TOKEN}` },
    });
    // console.log(standardPriceDataResponse.data);
    const standardPriceENData = standardPriceDataENResponse.data.data.attributes.priceList;

    const vipPriceDataCSResponse = await axios.get(`${process.env.API_URL}/api/cenik-vip-2?populate=*&locale=cs`, {
      headers: { Authorization: `Bearer ${process.env.STRAPI_TOKEN}` },
    });
    const vipPriceDataCS = vipPriceDataCSResponse.data.data.attributes.priceList;

    const vipPriceDataENResponse = await axios.get(`${process.env.API_URL}/api/cenik-vip-2?populate=*&locale=en`, {
      headers: { Authorization: `Bearer ${process.env.STRAPI_TOKEN}` },
    });
    const vipPriceDataEN = vipPriceDataENResponse.data.data.attributes.priceList;

    standardPriceData = {
      cs: standardPriceCSData,
      en: standardPriceENData,
    };

    vipPriceData = {
      cs: vipPriceDataCS,
      en: vipPriceDataEN,
    };
  } catch (error) {
    // console.error(error);
  }
  return {
    props: {
      standardPriceData,
      vipPriceData,
      ...(await serverSideTranslations(locale, ['common', 'priceList'])),
    },
    revalidate: 300,
  };
}
